import { createReducer, on } from '@ngrx/store';
import * as ServiceNotificationsActions from './service-notifications.actions';
import { ServiceNotificationsState } from './service-notifications.models';

export const initialState: ServiceNotificationsState = {
  notifications: [],
  loading: false,
  error: null,
};

export const serviceNotificationsReducer = createReducer(
  initialState,
  on(ServiceNotificationsActions.loadServiceNotifications, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ServiceNotificationsActions.loadServiceNotificationsSuccess, (state, { notifications }) => ({
    ...state,
    notifications,
    loading: false,
  })),
  on(ServiceNotificationsActions.loadServiceNotificationsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  on(ServiceNotificationsActions.markServiceNotificationAsRead, (state, { id }) => ({
    ...state,
    notifications: state.notifications.map(n =>
      n.id === id ? { ...n, read: true } : n
    ),
  })),
  on(ServiceNotificationsActions.patchServiceNotificationsSuccess, (state, { updates }) => ({
    ...state,
    notifications: state.notifications.map(notification => {
      const update = updates.find(u => u.id === notification.id);
      return update ? { ...notification, read: update.read } : notification;
    })
  }))
);
